import { Result } from 'antd-mobile';

const NotFound = () => {
  return (
    <div>
      <Result
        status="warning"
        title="404"
        subTitle="Sorry the page you visited does not exits "
      />
    </div>
  );
};

export default NotFound;
